import { useState, type FormEvent } from 'react';

/**
 * Botón que, al pulsarlo, pide el motivo antes de confirmar (desactivar, recargar…).
 * El motivo es obligatorio: queda en la versión y en la auditoría.
 */
export function ConMotivo({
  texto,
  confirmar,
  ayuda,
  alConfirmar,
  peligro = false,
}: {
  texto: string;
  confirmar: string;
  ayuda: string;
  alConfirmar: (motivo: string) => Promise<unknown>;
  peligro?: boolean;
}) {
  const [abierto, setAbierto] = useState(false);
  const [motivo, setMotivo] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  if (!abierto) {
    return (
      <button type="button" className={`boton ${peligro ? 'boton-peligro' : 'boton-secundario'}`} onClick={() => setAbierto(true)}>
        {texto}
      </button>
    );
  }

  const enviar = async (e: FormEvent) => {
    e.preventDefault();
    if (motivo.trim() === '') {
      setError('El motivo es obligatorio.');
      return;
    }
    setEnviando(true);
    setError(null);
    try {
      await alConfirmar(motivo.trim());
      setAbierto(false);
      setMotivo('');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'No se ha podido hacer.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <form className="con-motivo" onSubmit={enviar}>
      <label>
        {ayuda}
        <textarea value={motivo} onChange={(e) => setMotivo(e.target.value)} rows={2} autoFocus />
      </label>
      {error && <p className="error-campo" role="alert">{error}</p>}
      <div className="acciones">
        <button type="submit" className={`boton ${peligro ? 'boton-peligro' : 'boton-primario'}`} disabled={enviando}>
          {confirmar}
        </button>
        <button type="button" className="boton boton-claro" onClick={() => setAbierto(false)}>
          Cancelar
        </button>
      </div>
    </form>
  );
}
